var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareScreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.40039 12.7999C6.40039 9.78291 6.40039 8.27442 7.33765 7.33716C8.27491 6.3999 9.7834 6.3999 12.8004 6.3999H19.2004C22.2174 6.3999 23.7259 6.3999 24.6631 7.33716C25.6004 8.27442 25.6004 9.78291 25.6004 12.7999V18.1332C25.6004 20.1446 25.6004 21.1502 24.9756 21.7751C24.3507 22.3999 23.3451 22.3999 21.3337 22.3999H10.6671C8.65573 22.3999 7.65007 22.3999 7.02523 21.7751C6.40039 21.1502 6.40039 20.1446 6.40039 18.1332V12.7999Z",
    stroke: "#1A1B1B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6673 25.6001H5.33398",
    stroke: "#1A1B1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 19C15.25 19.4142 15.5858 19.75 16 19.75C16.4142 19.75 16.75 19.4142 16.75 19L16 19L15.25 19ZM16.5303 9.46967C16.2374 9.17678 15.7626 9.17678 15.4697 9.46967L10.6967 14.2426C10.4038 14.5355 10.4038 15.0104 10.6967 15.3033C10.9896 15.5962 11.4645 15.5962 11.7574 15.3033L16 11.0607L20.2426 15.3033C20.5355 15.5962 21.0104 15.5962 21.3033 15.3033C21.5962 15.0104 21.5962 14.5355 21.3033 14.2426L16.5303 9.46967ZM16 19L16.75 19L16.75 10L16 10L15.25 10L15.25 19L16 19Z",
    fill: "#1A1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareScreen);
export default __webpack_public_path__ + "static/media/share-screen.c1db57b70d95d95f50f75955e71f5ac5.svg";
export { ForwardRef as ReactComponent };